
export class LeadsCustomFilterCounts {
  new: number;
  open: number;
  pending: number;

  constructor(params?: LeadsCustomFilterCounts) {
    Object.assign(this, params);

  }
}
